/**
 * 
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
 * 
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class ProductService extends MainService {


    static listAllPagination(params) {
        return this.postSEC(ServiceConstant.PRODUCT_LIST_ALL_PAGINATION, params)
    }

    static listAll() {
        return this.postSEC(ServiceConstant.PRODUCT_LIST_ALL);
    }

    static get({idProduct}) {
        return this.postSEC(ServiceConstant.PRODUCT_GET, {idProduct});
    }

    static add(params) {
        return this.postSEC(ServiceConstant.PRODUCT_ADD, params);
    }

    static update(params) { 
        return this.postSEC(ServiceConstant.PRODUCT_UPDATE, params);
    }

    static delete({idProduct}) {
        return this.postSEC(ServiceConstant.PRODUCT_DELETE, {idProduct});
    }

}
